let roi_calculator_controller = {
    products:[],
    /**
     * This function will take a product with area and price properties and convert them to numbers. If the conversion fails, it will return null.
     * 
     * This is to ensure that all math we do with product stats is done with numbers and produces expected results.
     * @param {*} product 
     * @returns {id: string, area: number, price: number} or null if conversion fails
     */
    required_to_submit: [
        'competing_system',
        //'area_width',
        //'area_length',
        'area_sq_ft',
        'num-employees',
        'zip_code',
        'electricity_cost',
    ],
    submitting: false,
    submit_timer: null,
    loading_messages: [
        'Crunching some numbers...',
        'Adding it all up...',
        'Testing resistors...',
        'Running simulations...',
        'Comparing cooling methods...',
        'Evaluating the competition...',
        'Estimating the savings...',
        'Factoring in the variables...',
        'Running the numbers...',
        'Reviewing the data...',
        'Finalizing the results...',
    ],
    message_timer: null,
    debug: false, //Set to true to enable debug mode, which will log events to the console instead of sending them to the data layer.
    emitTagEvent: function(eventName, eventData){
        if(typeof eventData == 'undefined'){
            data = {};
        }
        if(
            typeof(gtm4wp_datalayer_name) !== 'undefined'
            && roi_calculator_controller.debug !== true
        ){

            var to_add = {
                'event': eventName,
                'eventCategory': 'portacool_roi_calc_event',
            };

            if(typeof eventData == 'object'){
                for(var key in eventData){
                    if(eventData.hasOwnProperty(key)){
                        to_add[key] = eventData[key];
                    }
                }

                //If we have utms, we add them to the event data
                if(
                    typeof ps_sku_tracker !== 'undefined'
                    && typeof ps_sku_tracker.utms !== 'undefined'
                ){
                    for(var key in ps_sku_tracker.utms){
                        to_add['utm_' + key] = ps_sku_tracker.utms[key];
                    }
                }

            }


            window[gtm4wp_datalayer_name].push(to_add);
        }else{
            console.log('EVENT FIRED', 'EVENT:', eventName, 'DATA:', eventData);
        }
    },
    can_submit: function(){
        //console.log('Checking if form can be submitted. Required fields: ', this.required_to_submit);
        for(let i = 0; i < this.required_to_submit.length; i++){
            let field_name = this.required_to_submit[i];
            let field = jQuery('[name="' + field_name + '"]');
            if(field.attr('type') == 'radio'){
                field = jQuery('[name="' + field_name + '"]:checked');
            }
            if(field.length == 0){
                console.error('Field ' + field_name + ' is required to submit ROI calculator form, but no input with that name was found.');
                return false;
            }
            let value = field.val();
            if(typeof value == 'undefined' || value === null || value === ''){
                console.error('Field ' + field_name + ' is required to submit ROI calculator form, but it is empty.');
                return false;
            }
            if(field_name == 'zip_code' && !/^\d{5}(-\d{4})?$/.test(value)){ //Validate zip code format
                console.error('Field ' + field_name + ' must be a valid zip code, but the value "' + value + '" was entered.');
                return false;
            }
        }
        //console.log('Form is ready to submit.');
        return true;
    },
    get_data_for_submission: function(){
        let data = {};
        let $form = jQuery('form.roi-calculator-form');
        //Serialize the form data
        let serialized_data = $form.serializeArray();
        for(let i = 0; i < serialized_data.length; i++){
            let field_name = serialized_data[i].name;
            let value = serialized_data[i].value;
            data[field_name] = value;
        }
        return data;
    },
    convert_product_stats_to_number: function(product){
        let converted_product = {
            product_id: product.product_id,
            area: Number(product.area),
            price: Number(product.price),
            name: product.name,
            featured_image_url: product.featured_image_url,
        };
        if (isNaN(converted_product.area) || isNaN(converted_product.price)){
            return null;
        }
        return converted_product;
    },
    /**
     * This function takes an area and finds the product that can cover that area for the lowest total price. It returns an object with the product id, number of units needed, and total price. If the area is invalid or if no products can cover the area, it returns null.
     * @param mixed area (number or string that can be converted to a number) 
     * @returns {product_id: string, num_needed: number, total_price: number} or null if area is invalid or no products can cover the area
     */
    best_fit_for_area_and_price: function(area){

        if(typeof area == 'undefined' || area <= 0){
            return null;
        }

        if(typeof area == 'string'){
            area = Number(area);
            if(area <= 0){ //Confirm our conversion was successful and the number is valid
                return null;
            }
        }

        let best_fit = null;
        for (let i = 0; i < this.products.length; i++){
            const converted_product = this.convert_product_stats_to_number(this.products[i]);
            if (converted_product === null){
                continue; //Skip this product if we can't convert its stats to numbers
            }
            let num_needed = Math.ceil(area / converted_product.area);
            let total_price = num_needed * converted_product.price;
            let possible_solution = {
                product_id: converted_product.product_id,
                num_needed: num_needed,
                individual_price: converted_product.price,
                total_price: total_price,
                name: converted_product.name, //Keep the name for debugging purposes, even though we won't be doing any math with it.
                sku: this.products[i].sku,
                featured_image_url: this.products[i].featured_image_url,
                link: this.products[i].link,
                area_per_unit: converted_product.area,
            };
            if (best_fit === null || possible_solution.total_price < best_fit.total_price){
                best_fit = possible_solution;
            }
        }
        return best_fit;
    },
    load_products: function(){
        if(typeof window.roiCalcData != 'undefined' && typeof window.roiCalcData.apexData != 'undefined'){
            for(let i in window.roiCalcData.apexData){
                if(typeof window.roiCalcData.apexData[i].name == 'undefined'){
                    window.roiCalcData.apexData[i].name = i; //Add the model number to each product for easier debugging.
                }
            }

            this.products = Object.values(window.roiCalcData.apexData);
        }else{
            console.error('No product data found for ROI calculator. Please ensure products are being passed to the frontend correctly.');
        }
    },
    format_price: function(price){
        return Number(price).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 2});
    },
    format_sqft: function(sqft){
        return Number(sqft).toLocaleString() + ' sq. ft.';
    },
    format_kwh: function(kwh){
        return Number(kwh).toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 2}) + ' kWh';
    },
    format_years: function(years){
        //This function converts a decimal number of years into a string with years and months. For example, 1.5 would be converted to "1 year and 6 months", and 0.25 would be converted to "3 months". It rounds to the nearest month for simplicity.
        let whole_years = Math.floor(years);
        let remaining_months = Math.round((years - whole_years) * 12);
        let year_string = whole_years > 0 ? whole_years + ' year' + (whole_years > 1 ? 's' : '') : '';
        let month_string = remaining_months > 0 ? remaining_months + ' month' + (remaining_months > 1 ? 's' : '') : '';
        if (year_string && month_string){
            return year_string + ' and ' + month_string;
        }
        return year_string || month_string || '0 years';
    },
    register_conditional:function($dom){
        let dependent = $dom.data('linked');
        let condition = $dom.data('condition');
        $dom.closest('form').find('[name="' + dependent + '"]').on('change', function(){
            if(jQuery(this).val() == condition){
                $dom.addClass('active');
            }else{
                if($dom.hasClass('active')){
                    $dom.removeClass('active');
                }
            }
        });

        //Initialize the conditional visibility on page load
        if($dom.closest('form').find('[name="' + dependent + '"]').val() == condition){
            $dom.addClass('active');
        }else{
            $dom.removeClass('active');
        }
    },
    get_random_loading_message: function(){
        return '<span class="loading-message">' + this.loading_messages[Math.floor(Math.random() * this.loading_messages.length)] + '</span>';
    },
    submit: function(best_fit){
        if(!this.can_submit()){
            this.submitting = false;
            clearTimeout(this.submit_timer);
            this.submit_timer = null;
            return;
        }

        let data = this.get_data_for_submission();
        let product_name = best_fit.name;
        const regex = /[^0-9]+/g; //Remove everything except numbers
        const model_number = product_name.replace(regex, '');
        data['model'] = model_number;
        data['count'] = best_fit.num_needed;

        let dialog = dialog_controller.display_dialog({
            content: this.get_random_loading_message() + '<br><i class="icon icon-spinner animate-spin"></i><br><small>Please wait as we fetch real weather data about your location.</small>',
            title: 'Calculating',
            header: '' //Including a blank header removes the close button
        }, [], 'roi_calc_loader');

        this.message_timer = setInterval(function(){
            let $message = dialog.find('.loading-message').addClass('out');
            setTimeout(function(){
                $message.remove();
            }, 500); //Wait for the fade out animation to finish before removing the old message
            dialog.find('.message').prepend(roi_calculator_controller.get_random_loading_message());
        }, 5000);

        this.emitTagEvent('roi_calculator_submission', data);

        jQuery.post(window.roiCalcData.ajaxUrl, data, function(response){
            //console.log('ROI calculator form submission response: ', response);
            if(response.error){
                dialog_controller.display_dialog({
                    content: '<p>Sorry, something went wrong while calculating your results. Please try again later.</p>',
                    title: 'Error',
                }, [], 'roi_calc_error');
                return;
            }
            let annual_savings = response.results.annual_productivity_savings;
            let payback_period = response.results.payback_period_years;
            let span_savings = response.results.productivity_savings_over_span;

            jQuery('.roi-results-container').find('.annual-savings .number').text(roi_calculator_controller.format_price(annual_savings));
            jQuery('.roi-results-container').find('.payback-period .number').text(roi_calculator_controller.format_years(payback_period));
            jQuery('.roi-results-container').find('.savings-per-period .number').text(roi_calculator_controller.format_price(span_savings));

            let additional_details_html = response.additional_details_html || '';
            jQuery('.roi-results-container').find('.add-details-output').html(additional_details_html);

            roi_calculator_controller.emitTagEvent('roi_calculator_results', response.results);

        }).fail(function(response){
            console.error('ROI calculator form submission failed.');
            //console.log('Response: ', response);
            dialog_controller.display_dialog({
                content: '<p>Sorry, something went wrong while calculating your results. Please try again later.</p>',
                title: 'Error',
            }, [], 'roi_calc_error');
        }).always(function(){
            roi_calculator_controller.submitting = false;
            roi_calculator_controller.submit_timer = setTimeout(function(){
                roi_calculator_controller.submit_timer = null;
            }, 10000); //Client side ratelimiting. This will be enforced on the server.
            dialog[0].close();
            dialog.remove();
        });
    },
    init: function(){
        this.load_products();

        if(typeof window.roiCalcData != 'undefined' && typeof window.roiCalcData.loading_messages != 'undefined' && window.roiCalcData.loading_messages.length > 0){
            this.loading_messages = window.roiCalcData.loading_messages;
        }

        jQuery('body').on('submit', '.roi-calculator-form', function(e){
            e.preventDefault(); //Prevent the default form submission behavior so we can handle it with AJAX.
            let area = jQuery('input[name="area_sq_ft"]').val();
            let width = jQuery('input[name="area_width"]').val();
            let length = jQuery('input[name="area_length"]').val();

            //Find the original target
            let target = jQuery(this);
            if(target.attr('name') == 'area_width' || target.attr('name') == 'area_length'){
                if(isNaN(width) || isNaN(length) || width <= 0 || length <= 0){
                    area = null; //If either width or length is invalid, we can't calculate an area, so treat it as if no area was entered.
                }else{
                    area = width * length; //Calculate the area based on the width and length inputs.
                    jQuery('input[name="area_sq_ft"]').val(area); //Update the area input with the calculated area for better user experience and to allow them to see the area they're calculating for.
                }
            }

            if(isNaN(area) || area <= 0 || area === null){
                return;
            }

            let best_fit = roi_calculator_controller.best_fit_for_area_and_price(area);

            if(best_fit !== null && roi_calculator_controller.can_submit()){
                //console.log('Should submit form with best fit: ', best_fit);

                //Emit an event
                jQuery('.roi-calculator-form').trigger('ready_to_submit', best_fit);

                if(roi_calculator_controller.submit_timer == null && roi_calculator_controller.submitting == false){
                    //console.log('Scheduling form submission.');
                    roi_calculator_controller.submitting = true;
                    setTimeout(function(){
                        roi_calculator_controller.submit(best_fit);
                    }, 500); //Submit the form after a short delay to ensure the input is complete and reduce the chance of multiple submissions.
                }
            }
        });

        jQuery('body').on('keyup change', '.roi-calculator-form input', function(){
            let area = jQuery('input[name="area_sq_ft"]').val();
            let width = jQuery('input[name="area_width"]').val();
            let length = jQuery('input[name="area_length"]').val();

            //Find the original target
            let target = jQuery(this);
            if(target.attr('name') == 'area_width' || target.attr('name') == 'area_length'){
                if(isNaN(width) || isNaN(length) || width <= 0 || length <= 0){
                    area = null; //If either width or length is invalid, we can't calculate an area, so treat it as if no area was entered.
                }else{
                    area = width * length; //Calculate the area based on the width and length inputs.
                    jQuery('input[name="area_sq_ft"]').val(area); //Update the area input with the calculated area for better user experience and to allow them to see the area they're calculating for.
                }
            }else if (target.attr('name') == 'area_sq_ft'){
                //If the user is directly editing the area input, we should clear the width and length inputs to avoid confusion about which inputs are being used to calculate the area.
                jQuery('input[name="area_width"]').val('');
                jQuery('input[name="area_length"]').val('');
            }
        });

        jQuery('body').on('click', 'button.expand-accordian', function(){
            let $this = jQuery(this);
            let target = $this.data('target');
            let $target = jQuery('.accordian-content[data-accordian="' + target + '"]');
            //console.log('Toggling accordian with target: ', target, $target);
            if($target.hasClass('active')){
                $target.removeClass('active');
                $this.removeClass('open');
            }else{
                $target.addClass('active');
                $this.addClass('open');
            }
        });

        jQuery('.roi-calculator-form .conditional').each(function(){
            roi_calculator_controller.register_conditional(jQuery(this));
        });

        jQuery('.roi-calculator-form input[name="competing_system"]').on('change', function(){
            //Get the currently checked radio
            let checked = jQuery('.roi-calculator-form input[name="competing_system"]:checked');
            const value = checked.val();
            if(value == 'yes'){
                //Get the template content
                let template = jQuery('template.roi-calc-existing-system-template').html();

                let dialog = dialog_controller.display_dialog({
                    content: template,
                    title: 'Did you know?',
                    class: 'roi-calc-existing-system-dialog',
                }, [], 'roi_calc_existing_system');
            }
        });
    }
};

window.roi_calculator_controller = roi_calculator_controller; //Expose controller to global scope for debugging

jQuery(document).ready(function(){
    roi_calculator_controller.init();
});